/**
 * Backfill / today-fill progress Redux slice.
 *
 * Tracks status and numeric progress (0–100) for two background
 * data-loading operations:
 * - **backfill** — 60 days of historical 1-min bars from REST API.
 * - **todayfill** — intraday bars from midnight to now.
 *
 * A progress value of `-1` means idle / not started (hides the progress bar).
 */
import { createSlice } from "@reduxjs/toolkit";

/** Shape of the backfill/todayfill progress state tree. */
export interface BackfillState {
  backfillStatus: string;
  todayfillStatus: string;
  backfillProgress: number;
  todayfillProgress: number;
}

const initialBackfillState: BackfillState = {
  backfillStatus: "",
  todayfillStatus: "",
  backfillProgress: -1,
  todayfillProgress: -1,
};

export const backfillSlice = createSlice({
  name: "backfill",
  initialState: initialBackfillState,
  reducers: {
    backfillStatusReducer: (state, action) => {
      state.backfillStatus = action.payload.backfillStatus;
    },
    todayfillStatusReducer: (state, action) => {
      state.todayfillStatus = action.payload.todayfillStatus;
    },
    backfillProgressReducer: (state, action) => {
      state.backfillProgress = action.payload.backfillProgress;
    },
    todayfillProgressReducer: (state, action) => {
      state.todayfillProgress = action.payload.todayfillProgress;
    },
  },
});

export const {
  backfillStatusReducer,
  todayfillStatusReducer,
  backfillProgressReducer,
  todayfillProgressReducer,
} = backfillSlice.actions;
export default backfillSlice.reducer;
